import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import * as backInter from 'app/auth/auth-data.model';
import { Subject } from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef} from '@angular/material/dialog';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_dispatch } from 'app/idiomas/i18n/dispatch/dispatch.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { lang_eschedule_izzi } from 'app/idiomas/i18n/Izzi/shedule/shedule.lang';
import { lang_cierre } from 'app/idiomas/i18n/cierre/cierre.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { AuthService } from 'app/auth/auth.service';

@Component({
  selector: 'app-creacion',
  templateUrl: './creacion.component.html',
  styleUrls: ['./creacion.component.scss']
})
export class CreacionComponent implements OnInit {

  @ViewChild('pasos') pasos: MatStepper;
  actualizaPaso: Subject<any> = new Subject<any>();
  displayedColumns: string[] = ['name', 'weight','status','action'];
  encuestaCreada: boolean;
  usuariosTest: any[] = [];
  url: string;
  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  //boolean paso completo
  pasoCompleto = false;

  userData:any;
  validationUser:boolean=false;
  validationSurvey:boolean=false;
  token:any;
  desbloqueoEstatus:boolean=false;
  usuariosAsignados:any[]=[];
  usuariosNoAsignados:any[]=[];
  modalCambios:boolean=false;

  constructor(
    private translateSrv: TranslateService,
    private wizardService: WizardService,
    private encuestaService: EncuestaService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) {
    lang_dispatch.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_cierre.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    if(localStorage.getItem('tipoIzzi')){
      lang_eschedule_izzi.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
    }
    else{
      lang_shedule.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
    }

    if(localStorage.getItem('userBypass')){
      this.userData=JSON.parse(localStorage.getItem('userBypass'));
      // console.log(this.userData.level);
      if(this.userData.level==3 || this.userData.level==2){
        this.validationUser=true;
      }
      else{
        this.validationUser=false;
      }
    }
  }

  ngOnInit() {
    this.obtieneCertificarActual();
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.encuestaService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
        prodsCertificar.forEach( (producto) => {
          let fecha = producto.fechaCertificar;
          let idProducto = producto.idCertificar;
          if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
            this.productoCertificar = producto;
            console.log(this.productoCertificar );
          //   this.modalCambios=producto.modalCambios;
          //   if (this.modalCambios) {
          //     let recreateSurve = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.DETEC_CAMBIOS_SECCIONES';
          //     let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.CERRAR';
          // this.translateSrv.get(recreateSurve).subscribe((res: string) => { recreateSurve = res; });
          // this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
          // Swal.fire({
          //   icon: 'warning',
          //   title: recreateSurve,
          //   showConfirmButton: true,
          //   
          //   confirmButtonText: cerrar,
          // })
          //   }

            this.token=producto.tokenConfig;
            this.getStatusEncuesta(this.token);
            this.getEstatusDesbloqueo();
            // this.surveyCheckService(this.token);
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      // this.encuestaService.getStatusProgramacion(parseInt(localStorage.getItem('fechaProducto'))).subscribe( (data: backInter.getStatusIndiv) => {
      //   if(data.estatus === 3)
      //     this.pasoCompleto = true;
      // });
      // this.getStatusModal();
      this.getStatusSeccion();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoCertificar.idCertificar).subscribe((respuesta:any) => {
      console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo==true){
        this.desbloqueoEstatus=true;
      }
      else{
        this.desbloqueoEstatus=false;
      }
    });
  }

  getStatusEncuesta(token:any){
    if(token){
      this.wizardService.getStatusEncuesta(token).subscribe( (data:any) => {
        // console.log(data);
        if(data.result.id_status==1){
          this.validationSurvey=true;
        }
        else{
          this.validationSurvey=false;
        }
      });
    }
  }

  getStatusSeccion(){
    this.encuestaService.getStatusEncuesta(this.productoCertificar.idCertificar).subscribe( (data: backInter.getStatusIndiv) => {
      if(data.estatus === 3)
      this.pasoCompleto = true;
    });
  }

  datosPiloto(datos:any){
    console.log("datosPiloto:",datos);
    // this.dataPiloto = datos.data;
    this.usuariosTest = datos.data.piloto.usuariosTest
    this.usuariosTest.sort( (a,b) => {
      if(a.asignado < b.asignado){
        return -1;
      } else{
        return 1;
      }
    });
    let usuariosAsignados:any[] = [];
    let usuariosNoAsignados:any[] = [];
    this.usuariosTest.forEach(element => {
      if (element.asignado==true) {
        usuariosAsignados.push(element);
      }else{
        usuariosNoAsignados.push(element);
      }

    });
    this.usuariosAsignados=usuariosAsignados;
    this.usuariosNoAsignados=usuariosNoAsignados;
    console.log("No asignados: ",this.usuariosNoAsignados);

    console.log(this.usuariosTest);

    this.url = datos.data.piloto.url;
    this.encuestaCreada = datos.procesoFinalizado;
    if(!this.encuestaCreada){
      if(datos.productoCertificar.idSurvey){
        console.log("Tiene survey creada");
        this.encuestaCreada=true;
      }
    }
    // this.productoCertificar = datos.productoCertificar;
    // console.log(this.productoCertificar);

    console.log("Pilotos");
    // console.log(this.usuariosTest);
  }

  // actualizaFlagCambios(status:boolean){
  //   if (status) {
  //     this.obtieneCertificarActual();
  //   }
  // }

  cambiaPaso(numero:number){
    this.pasos.selectedIndex = numero;
  }

  completarPaso(){
    if(this.pasoCompleto){
      //this.aletaRestric('PROGRAMACION.COMPLETADO',null,'warning');
      let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
      this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
      //this.alertaRestric2('IDIOMAS.COMPLETADO',null,'warning');
      this._snackBar.open(textomessage, "Ok", {
        duration: 2000,
        horizontalPosition: "center",
        verticalPosition: 'bottom',
        panelClass: ['background-red']
      });
    }else{
      if(this.encuestaCreada){
        this.aletaRestric('PROGRAMACION.GENERAR',true);
      }else{
        Swal.fire(this.translateSrv.instant('SHEDULE.LAUNCH_SURVEY'));
      }
    }
  }

  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  desbloquearEncuesta(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.TITULO_DESBLOQUEAR';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
      Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          let datos={
            accionText:'DescompletePasEncues',
            productoId:this.productoCertificar.idCertificar,
            encuesta: 2
          }
          console.log("Descompletar paso Encuesta");

          this.encuestaService.DesbloquearPasoEncuesta(datos).subscribe( (data: backInter.RespuestaGen) => {
            console.log(data);
            if(data.message == '217'){
              this.pasoCompleto = false;
              this.openSnackBar(succes,"OK");
              this.enviaOrdenWizard();
              this.actualizaPaso.next(this.pasoCompleto);
              /*Swal.fire({
              icon: 'success',
              title: succes,
              showConfirmButton: true,
              
              confirmButtonText: cerrar,
            })*/
          };
        });
      }
    });
  }
  else{
    Swal.fire({
      icon: 'warning',
      title: bloqueado,
      showConfirmButton: true,
      
      confirmButtonText: cerrar,
    })
  }
}

openSnackBar(message: string, action: string) {
  this._snackBar.open(message, action, {
    duration: 2000,
  });
}

aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

  let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
  let rspSi = 'MODALES.ACCIONES.aceptar';
  let rspNo = 'MODALES.ACCIONES.cancelar';
  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
  this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
  this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
//   if (this.modalCambios) {
//
//     let recreateSurve = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.DETEC_CAMBIOS_SECCIONES';
//     let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.CERRAR';
// this.translateSrv.get(recreateSurve).subscribe((res: string) => { recreateSurve = res; });
// this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
// Swal.fire({
//   icon: 'warning',
//   title: recreateSurve,
//   showConfirmButton: true,
//   
//   confirmButtonText: cerrar,
// })
//
// }else{
  if(confirmar){
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      
      
      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        let datos={
          accionText:'completePasEncues',
          productoId:this.productoCertificar.idCertificar,
          encuesta: 3
        }
        console.log("completar paso Encuesta");
        this.encuestaService.guardaStatusEncuesta(datos).subscribe( (data: backInter.RespuestaGen) => {
          if(data.message == '217'){
            //this.aletaRestric('PROGRAMACION.'+data.message,null,'success');
            let textoMensaje ="MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.210";
            this.translateSrv.get(textoMensaje).subscribe((res: string) => { textoMensaje = res; });
            this.openSnackBar(textoMensaje,"OK");
            this.pasoCompleto = true;
            this.enviaOrdenWizard();
            this.actualizaPaso.next(this.pasoCompleto);
          };
        });
      }
    });
  }
  else{
    let tipoMsg: any = tipo;
    Swal.fire({
      title: texto,
      icon: tipoMsg,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

// }


}
rutaPagina :any;
copyMessage(val: string,claveId:string){
  console.log(claveId);

  let texto = 'CIERRE.CIERRE.COPYLINK';
  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
  // let url = DATOS_API.url.split(":");
  // this.rutaPagina = url[1] + "/surveyadministrator/counting/" + val;
  this.rutaPagina =  val;
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  // selBox.value=val;
  selBox.value=this.rutaPagina;
  console.log(this.rutaPagina);
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  /*Swal.fire({
  icon: 'success',
  title: texto,
  
});*/
this.modalAsignandoUsuarioDemo();
this.asignarUsuariaDemoEncu(claveId);
}


asignarUsuariaDemoEncu(claveId){
  let texto = 'CIERRE.CIERRE.COPYLINK';
  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });

  console.log('ESTA ES SUCLAVE',claveId);
  this.encuestaService.getAsignacionUsuarioDemo(claveId).subscribe( (data: any) => {
    console.log("asignar clave ", data);
    Swal.close();
    this.getPilotoDataEncuesta();
    Swal.fire({
      icon: 'success',
      title: texto,
      
    });

  });
}

getPilotoDataEncuesta(){
  let data={
    productoId: this.productoCertificar.idCertificar
  };
  this.encuestaService.getPilotoDataEncuesta(data).subscribe((data: backInter.getEncuestaPilotoC2) => {
    // console.log("getPilotoData:",data);
    this.usuariosTest = data.piloto.usuariosTest;
    this.usuariosTest.sort( (a,b) => {
      if(a.asignado < b.asignado){
        return -1;
      } else{
        return 1;
      }
    });
    console.log(this.usuariosTest);
    let usuariosAsignados:any[] = [];
    let usuariosNoAsignados:any[] = [];
    this.usuariosTest.forEach(element => {
      if (element.asignado==true) {
        usuariosAsignados.push(element);
      }else{
        usuariosNoAsignados.push(element);
      }

    });
    this.usuariosAsignados=usuariosAsignados;
    this.usuariosNoAsignados=usuariosNoAsignados;
    console.log("No asignados: ",this.usuariosNoAsignados);


  });
}

modalAsignandoUsuarioDemo(){
  let mensaje: string;
  this.translateSrv.get('CIERRE.CIERRE.ASIGUSERDEMO').subscribe((res: string) => { mensaje = res; });

  Swal.fire({
    title: mensaje,
    allowOutsideClick: false,

    didOpen: () => {
      Swal.showLoading()
    }
  });
}



// updateNameUrl(){
//
//
//   Swal.fire({
//     title: 'Ingresa el nombre',
//     input: 'text',
//     inputAttributes: {
//       autocapitalize: 'off'
//     },
//     showCancelButton: true,
//     confirmButtonText: 'Aceptar',
//     showLoaderOnConfirm: true,
//     allowOutsideClick: () => !Swal.isLoading()
//   }).then((result) => {
//
//     if (result.value) {
//       let numNombre= result.value.length;
//       console.log(numNombre);
//          if(numNombre <= this.caracteresNombreUrl){
//         Swal.fire({
//           title: 'se modifico correctamente'
//         })
// }
// else{
//   Swal.fire({
//     title: 'excede elnumero de caracteres'
//   })
// }
//
//     }
//   })
// }


openEditarUrlEncuesta() {

const dialogRef = this.dialog.open(DialogEditUrlEncuesta,{
height: '39%',
width: '37%',
});
dialogRef.afterClosed().subscribe(result => {
console.log(`Dialog result: ${result}`);

});
}
}




@Component({
  selector: 'editUsuario',
  templateUrl: 'editUrl.html',
  styleUrls: ['./editUrl.component.scss'],
})

export class DialogEditUrlEncuesta {
  caracteresNombreUrl=6;
  constructor(
    public dialogActualizar: MatDialogRef<DialogEditUrlEncuesta>,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    public authService: AuthService,
  ){
  }
  ngOnInit() {

  }


  onClose(): void {
      this.dialogActualizar.close();
    }



}
